import DeepWellLabel from 'components/DeepWellLabel';
import PropTypes from 'prop-types';

function TaskTitle({isDeepWell, title, description}) {
  return (
    <div className="task-description">
      {isDeepWell ? (
        <span className="deep-well-label">
          <DeepWellLabel />
          &nbsp;
        </span>
      ) : (
        ''
      )}
      <span className="bold">{title}</span>
      {description}
    </div>
  );
}

TaskTitle.propTypes = {
  isDeepWell: PropTypes.bool,
  description: PropTypes.string,
  title: PropTypes.string,
};

TaskTitle.defaultProps = {
  isDeepWell: false,
  description: '',
  title: '',
};

export default TaskTitle;
